import type { AccountId, BaseUrl } from '@atlassian/jira-shared-types';

export const getUserUrl = (baseUrl: BaseUrl, accountId: AccountId) => {
	const userQuery = `accountId=${encodeURIComponent(accountId)}`;
	return `${baseUrl}/rest/api/2/user?${userQuery}`;
};
